import { inject } from '@angular/core';

import { MobiUiLanguage } from '@mobi/rwc-ui-components-ng-jslib';
import { FaviconService } from '@mobi/rwc-uxframework-ng';

import { B2C, MOBILIAR } from '../../common.constant';

import { AppSettingProvider, getLinks } from './app-setting.provider';

export class MobiliarB2cSettingProvider implements AppSettingProvider {
    #favicon = inject(FaviconService);
    constructor() {
        this.#favicon.activateMobiliarFavicon();
    }
    getAppSetting() {
        return {
            source: MOBILIAR,
            context: B2C,
            language: 'de' as MobiUiLanguage,
            links: getLinks('de', MOBILIAR),
        };
    }
}
